import * as locationTypes from '../../../../common/redux/actions/types/LocationTypes';

export default function filterOperatorUserIfExistsInPostalOperators(
  operatorUsers,
  postalOperators,
  reportDefinition,
) {
  const result = [];

  if (!reportDefinition || !postalOperators || postalOperators.length === 0) {
    return [...operatorUsers];
  }

  const addIfExists = (operatorUserCode) => {
    if (operatorUsers.includes(operatorUserCode)) {
      result.push(operatorUserCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];

    addIfExists(postalOperator.value);
    // eslint-disable-next-line
    for (let i = 0; i < postalOperator.children.length; i++) {
      const operatorUser = postalOperator.children[i];
      if (reportDefinition.locationType === locationTypes.OPERATOR) {
        if (operatorUsers.includes(operatorUser.value)) {
          result.push(...postalOperator.children.map(child => child.value));
          break;
        }
      } else {
        addIfExists(operatorUser.value);
      }
    }
  }

  return result;
}
